import { jsx } from "react/jsx-runtime";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { validateTidalLicense } from "../../base/index.js";
function QrCodeScanner(props) {
  return /* @__PURE__ */ jsx(
    QrCodeScannerIcon,
    {
      "data-testid": "QrCodeScanner",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "QrCodeScanner",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
QrCodeScanner.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "QrCodeScanner"
};
validateTidalLicense();
export {
  QrCodeScanner
};
//# sourceMappingURL=QrCodeScanner.js.map
